const c = (o, t = 10) => {
  o || (o = 1);
  const r = Number(o) * t - 1;
  return { from: r - t + 1, to: r };
}, m = "...";
export {
  m as DOTS,
  c as getFromTo
};
